import React from 'react';

import { Grid, Box } from '@gogame/components';
import { FormField, withForm, SidePageV2 } from '@gogame/form';

import {
  loadActivities,
  loadMetrics,
  loadTraffics,
  loadGenres,
  loadApplications,
  loadNetworks,
  loadPlatforms,
  loadCountries,
  loadRegistrations,
  loadFrauds,
} from 'scenes/KPI/sources/fields';

import { DescriptionOptionTemplate } from './DescriptionOptionTemplate';
import {
  ACTIVITY,
  METRIC,
  TRAFFIC,
  GENRES,
  APPLICATIONS,
  NETWORKS,
  PLATFORMS,
  COUNTRIES,
  REGISTRATIONS,
  SAME_AS_FIRST,
  DEPENDENCIES,
  FRAUD,
} from './constants';
import { kpiSeriesSchema } from './schemas';

const KPIForm = withForm({
  validationSchema: kpiSeriesSchema,
  enableReinitialize: true,
})(
  ({
    children,
    title,
    loading,
    onClose,
    asFirstTableRowDisabled,
    onExited,
    open,
  }) => {
    return (
      <SidePageV2
        onClose={onClose}
        onExited={onExited}
        open={open}
        loading={loading}
        size={'sm'}
      >
        <SidePageV2.Title title={title} />
        <SidePageV2.NewBody loading={loading} scroll={false}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormField.Select
                name={ACTIVITY}
                label={'Activity'}
                source={loadActivities}
                lazy={true}
                padding={0}
                required={true}
              />
            </Grid>
            <Grid item xs={12}>
              <FormField.Select
                name={METRIC}
                label={'Metric'}
                source={loadMetrics}
                renderOption={DescriptionOptionTemplate}
                lazy={true}
                padding={0}
                required={true}
              />
            </Grid>
            <Grid item xs={12}>
              <FormField.Select
                name={TRAFFIC}
                label={'Traffic'}
                source={loadTraffics}
                depends={DEPENDENCIES[TRAFFIC]}
                lazy={true}
                padding={0}
                required={true}
              />
            </Grid>
            <Grid item xs={12}>
              <FormField.MultiSelect
                name={GENRES}
                label={'Genres'}
                placeholder={'All'}
                source={loadGenres}
                lazy={true}
                withAll={false}
                padding={0}
              />
            </Grid>
            <Grid item xs={12}>
              <FormField.MultiSelect
                name={APPLICATIONS}
                label={'Applications'}
                placeholder={'All'}
                source={loadApplications}
                depends={DEPENDENCIES[APPLICATIONS]}
                lazy={true}
                withAll={false}
                padding={0}
              />
            </Grid>
            <Grid item xs={12}>
              <FormField.MultiSelect
                name={NETWORKS}
                label={'Networks'}
                placeholder={'All'}
                source={loadNetworks}
                depends={DEPENDENCIES[NETWORKS]}
                lazy={true}
                withAll={false}
                padding={0}
              />
            </Grid>
            <Grid item xs={12}>
              <FormField.MultiSelect
                name={PLATFORMS}
                label={'Platforms'}
                source={loadPlatforms}
                placeholder={'All'}
                depends={DEPENDENCIES[PLATFORMS]}
                lazy={true}
                withAll={false}
                padding={0}
              />
            </Grid>
            <Grid item xs={12}>
              <FormField.MultiSelect
                name={COUNTRIES}
                label={'Countries'}
                placeholder={'All'}
                withAll={false}
                source={loadCountries}
                lazy={true}
                padding={0}
              />
            </Grid>
            <Grid item xs={12}>
              <FormField.Select
                name={REGISTRATIONS}
                label={'Bots regs'}
                source={loadRegistrations}
                depends={DEPENDENCIES[REGISTRATIONS]}
                lazy={true}
                padding={0}
              />
            </Grid>
            <Grid item xs={12}>
              <FormField.Select
                name={FRAUD}
                label={'Fraud'}
                source={loadFrauds}
                lazy={true}
                padding={0}
                depends={DEPENDENCIES[FRAUD]}
              />
            </Grid>
          </Grid>
        </SidePageV2.NewBody>
        <SidePageV2.Actions>
          <Box pl={1.5} display={'flex'} width={'100%'}>
            <FormField.Checkbox
              name={SAME_AS_FIRST}
              label={'Same as first table row'}
              disabled={asFirstTableRowDisabled}
              padding={0}
            />
          </Box>
          <SidePageV2.CloseButton />
          <SidePageV2.SubmitButton />
        </SidePageV2.Actions>
        {children}
      </SidePageV2>
    );
  }
);

export default KPIForm;
